export const reasonCodesConfig = [
    // Visa Reason Codes
    { id: "10.1", name: "Fraudulent—Card Present Environment" },
    { id: "10.2", name: "Fraudulent—Card Absent Environment" },
    { id: "10.3", name: "Fraudulent—Multiple Transactions" },
    { id: "11.1", name: "Card Recovery Bulletin or Exception File" },
    { id: "12.1", name: "Late Presentment" },
    { id: "12.3", name: "Incorrect Transaction Currency or Amount" },
    { id: "13.1", name: "Merchandise/Services Not Received" },
    { id: "13.2", name: "Canceled Recurring Transaction" },
    { id: "13.3", name: "Not as Described or Defective Merchandise/Services" },

    // Mastercard Reason Codes
    { id: "4837", name: "No Cardholder Authorization" },
    { id: "4842", name: "Late Presentment" },
    { id: "4853", name: "Cardholder Dispute—Defective/Not as Described" },
    { id: "4863", name: "Cardholder Dispute—Services Not Rendered" },
    { id: "4870", name: "Chip Liability Shift" },
    { id: "4871", name: "Chip/PIN Liability Shift" },

    // American Express Reason Codes
    { id: "F24", name: "Fraudulent Transaction—Card Present" },
    { id: "F29", name: "Fraudulent Transaction—No Card Present" },
    { id: "C08", name: "Goods/Services Not Received" },
    { id: "C14", name: "Canceled Recurring Billing" },
    { id: "P05", name: "Incorrect Transaction Amount" },
    { id: "R13", name: "Cancelled/Returned Merchandise" },

    // Discover Reason Codes
    { id: "4752", name: "Fraud—Card Not Present Transaction" },
    { id: "4753", name: "Fraud—Card Present Transaction" },
    { id: "4541", name: "Goods/Services Not Received" },
    { id: "4553", name: "Defective/Not as Described Merchandise" },
    { id: "4510", name: "Canceled Recurring Transaction" },
    { id: "4580", name: "Duplicate Processing" }
];
